import React from "react";
import { connect } from "react-redux";
import BarchartHolder from "./barchartHolder";
import WithCard from "../../../../common/withCard";

const MonthlyPerformance = (props) => {
  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <WithCard>
          <BarchartHolder {...props} />
        </WithCard>
      </div>
    </div>
  );
};

export default connect(
  ({
    create: {
      steps: {
        risk: { benchmark_name, display_orig_portfolio },
        universeLite: { analyze_compare, model_name },
      },
    },
  }) => ({
    benchmark_name,
    analyze_compare,
    display_orig_portfolio,
    client_histmetric: analyze_compare.getPerfHistmetrics,
    model_name,
  }),
  null
)(MonthlyPerformance);



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/monthlyPerformance/monthlyPerformance.jsx